export function uiLocale(language) {
  const lng = String(language || "").toLowerCase();
  if (lng.startsWith("zh-cn")) return "zh-cn";
  if (lng.startsWith("zh")) return "zh-tw";
  return "en";
}
